export function isNotBlank(str){
   if(str === undefined){
       return false;
   }

   if(str === null){
    return false;
    }

    if(str === ''){
        return false;
    }

    if(str.length === 0){
        return false;
    }
    return true;

  };

  export function isBlank(str){
    if(str === undefined){
        return true;
    }

    if(str === null){
     return true;
     }

     if(str === ''){
         return true;
     }

     if(str.length === 0){
        return true;
    }
     return false;

   };
export function checkPhone(phone){

    if(!(/^1[3456789]\d{9}$/.test(phone))){
        //alert("手机号码有误，请重填");
        return false;
    }
    else return true;
};
